// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1dwkq","colMaxWidth":"Table_colMaxWidth__ShtiO"};